import React, {ReactNode, useState} from 'react'
import styled from 'styled-components'
import Modal from '@mui/material/Modal'
import modalStyles, {
  modalBoxStyles,
  pageContentStyles,
} from './demo_modal.styles'
import ButtonAtom from '../../to_forms/button/button.atom'

interface ApModalProps {
  children: ReactNode
}

const PageContent = styled.div`
  ${pageContentStyles};
`
const ModalBox = styled.div`
  ${modalBoxStyles};
`
const apAtomName = {ap_atom_name: 'apModalAtom'}
const DemoModalAtom = styled((props: ApModalProps) => {
  const [show, setShow] = useState(false)

  const handleClick = () => {
    setShow(true)
  }
  const handleClose = () => {
    setShow(false)
  }

  return (
    <>
      <Modal {...apAtomName} {...props} open={show} onClose={handleClose}>
        <ModalBox>{props.children}</ModalBox>
      </Modal>

      <PageContent>{props.children}</PageContent>
      <ButtonAtom ap_type="primary" onClick={handleClick}>
        Open Modal
      </ButtonAtom>
    </>
  )
})`
  ${modalStyles};
`

export default DemoModalAtom
